module.exports = __webpack_public_path__ + "img/acc_carousel_03.7795d5e3.jpg";